<!-- template for native/html5 video -->
@if (videoType === 'native') {
  <div class="video-container" #VideoContainer
    [ngClass]="{
      'is-active': videoStatus,
      'is-paused': videoStatus === 'paused',
      'is-playing': videoStatus === 'playing'
    }">
    <video class="video-embed" playsinline controls disablepictureinpicture controlslist="nodownload"
      [src]="videoUrl"
      (error)="onVideoError()"
      (pause)="onVideoPaused()"
      (playing)="onVideoPlaying()"
      (webkitfullscreenchange)="onFullscreenStateChange()"></video>
    <ion-button mode="ios" class="proto-button video-play-button" shape="round" color="lighter"
      (click)="startVideo($event)">
      @if (videoStatus === 'loading') {
        <ion-spinner color="dark"></ion-spinner>
      } @else {
        <ion-icon name="play-sharp"></ion-icon>
      }
    </ion-button>
  </div>
}

<!-- template for iframe video -->
@if (videoType !== 'native') {
  <div class="video-container">
    @if (videoUrl) {
      <p class="video-message">{{ 'TERM.LOADING_VIDEO' | translate }}</p>
      
      <iframe class="video-embed" frameborder="0" allow="encrypted-media;" allowfullscreen
        [src]="videoUrl | bypassSecurityTrustUrl"
        [attr.id]="videoUrl"
        tabindex="0"></iframe>
    }
  </div>
}
